import { render, staticRenderFns } from "./ExpertCallback.vue?vue&type=template&id=8523aa96&scoped=true&"
import script from "./ExpertCallback.vue?vue&type=script&lang=js&"
export * from "./ExpertCallback.vue?vue&type=script&lang=js&"
import style0 from "./ExpertCallback.vue?vue&type=style&index=0&id=8523aa96&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8523aa96",
  null
  
)

export default component.exports